import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/pleasanton")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Pleasanton, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Pleasanton & Atascosa County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Pleasanton, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Pleasanton and Atascosa County.",
      keywords: "awnings Pleasanton, awning company Pleasanton, custom awnings Pleasanton, sail shades Pleasanton, patio covers Pleasanton, pergola covers Pleasanton, metal awnings Pleasanton, canvas awnings Pleasanton, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Pleasanton", "Atascosa County"),
  }),
  component: () => <CityHomePage city="Pleasanton" region="Atascosa County" />,
});
